<template>
  <form class="form form-asm-first-login" @submit.prevent="postForm">
    <slide-x-left-transition :duration="400" :delay="300">
      <div class="form-group" v-show="show">
        <label>Hasło</label>
        <div class="input-wrapper">
          <input v-model="form.password"
                 type="password"
                 :class="{'input-error' : errors.password }"
                 placeholder="Podaj swoje hasło"
                 ref="passwordInput"
                 required/>
        </div>
        <p class="error" v-if="errors.password">{{ errors.password[0] }}</p>
        <p class="text-small text-gray-light">Hasło powinno zawierać: jedną wielką literę, jedną małą
          literę, jedną cyfrę lub znak specjalny i min. 8 znaków.</p>
      </div>
    </slide-x-left-transition>

    <slide-x-left-transition :duration="500" :delay="400">
      <div class="form-group" v-show="show">
        <label>Powtórz hasło</label>
        <div class="input-wrapper">
          <input v-model="form.password_confirmation"
                 type="password"
                 :class="{'input-error' : errors.password_confirmation }"
                 placeholder="Powtórz swoje hasło"
                 ref="passwordConfirmationInput"
                 required/>
        </div>
        <p class="error" v-if="errors.password_confirmation">{{ errors.password_confirmation[0] }}</p>
      </div>
    </slide-x-left-transition>

    <slide-x-left-transition :duration="400" :delay="500">
      <div v-if="show">
        <h6 class="text-up">Dokumenty</h6>
        <hr>
      </div>
    </slide-x-left-transition>

    <slide-y-up-transition :duration="400" :delay="600">
      <div v-if="show">
        <ion-button mode="ios"
                    fill="outline"
                    size="small"
                    @click="goTo(url_to_legal)">Regulamin</ion-button>
        <ion-button mode="ios"
                    fill="outline"
                    size="small"
                    @click="goTo(url_to_privacy_policy)">Polityka prywatności</ion-button>
      </div>
    </slide-y-up-transition>

    <slide-x-left-transition :duration="400" :delay="700">
      <div v-if="show">
        <h6 class="text-up">Zgody</h6>
        <hr>
      </div>
    </slide-x-left-transition>

    <slide-x-left-transition :duration="600" :delay="800">
      <div class="form-group" v-show="show">
        <template v-for="(item,index) in asm_agreements">
          <div class="input-wrapper">
            <!--v-model not working - value is passed as props 'checked'-->
            <ion-checkbox mode="md"
                          :checked="tempAgreements.length > 0 ? tempAgreements[index].isChecked : false"
                          @input="checked = target.value"
                          @ionChange="handleCheckbox($event, index, item.key, $event.target.value)">
            </ion-checkbox>
            <label class="checkbox-label">
              <i class="checkbox-caret" v-if="item.required">*</i>
              <div v-html="item.value"></div>
            </label>
          </div>
          <p class="error"
             v-if="errors['agreements.rodo.'+ item.key]"
             v-text="errors['agreements.rodo.'+ item.key][0]">
          </p>
        </template>
      </div>
    </slide-x-left-transition>

    <ion-button mode="ios" expand="block" type="submit" :disabled="loading">
      <span v-if="loading"><span class="loader"></span></span>
      <span v-else>Wyślij</span>
    </ion-button>

  </form>
</template>

<script>
  import {mapState} from 'vuex';
  import { cloneDeep } from 'lodash';

  export default {
    name: 'FormAsmFirstLogin',
    computed: {
      ...mapState({
        loading: state => state.auth.loading,
        errors: state => state.auth.errors,
        asm_agreements: state => state.global.agreements.rodo,
      })
    },
    data() {
      return {
        show: false,
        form: {
          password: '',
          password_confirmation: '',
          agreements: {
            rodo: {}  // dynamic (group name requested 5956#note-26)
          }
        },
        tempAgreements: [], // helper
        url_to_legal: 'https://portalgastro.pl/pdf/Portal_Gastro_Regulamin.pdf', // TODO?
        url_to_privacy_policy: 'https://portalgastro.pl/pdf/polityka-prywatnosci.pdf', // TODO?
      }
    },
    mounted() {
      this.$store.commit('profile/PROFILE_SET_HEADER_DISABLED', true);
      this.show = true;
      // copy global agreements to local halper and unbind two-way
      this.tempAgreements = _.cloneDeep(this.asm_agreements)
      // set all agreements to false (requested)
      this.tempAgreements.forEach((item) => {
        let obj = { [item.key]: false }
        Object.assign(this.form.agreements.rodo, obj)
      })
    },
    methods: {
      handleCheckbox(event, i, key, value) {
        const checkbox = event.target
        // prepare agreements
        let obj = {
          [key]: value == "on" ? true : false
        }
        // checkbox is set true
        if (checkbox.checked) {
          this.tempAgreements[i].isChecked = true
          Object.assign(this.form.agreements.rodo, obj)
        }
        // checkbox is set false
        else {
          this.tempAgreements[i].isChecked = false
          // Object.assign(this.form.agreements.rodo, obj)
          this.$set(this.form.agreements.rodo, key, false)
        }
      },
      postForm(e) {
        this.$store.dispatch('AUTH_ASM_FIRST_LOGIN_REQUEST', this.form)
            .then(() => {
              this.$router.push({name: 'Dashboard'}).catch(err => {})
              this.$store.commit('profile/PROFILE_SET_HEADER_DISABLED', false);
              return this.$store.dispatch('GLOBAL_TOAST','Otrzymaliśmy Twoje zgody.');
            })
            .catch(() => {
              this.$store.dispatch('GLOBAL_TOAST','Błąd rejestracji.');
            })
      },
    }
  }
</script>